export default __webpack_public_path__ + "static/media/paprika_jancsi_etterem_04.94023d25.JPG";